import React, { useEffect, useRef, useState } from "react";

const ForexWebSocket = () => {
    const [messages, setMessages] = useState([]);
    const bufferRef = useRef([]); // Temporary buffer for incoming messages

    useEffect(() => {
        const socket = new WebSocket(
            "wss://data.tradingview.com/socket.io/websocket"
        );

        socket.onopen = () => {
            console.log("✅ Connected to WebSocket");
            // Example: subscription (depends on API spec)
            // socket.send(JSON.stringify({ type: "subscribe", symbol: "EURUSD" }));
        };

        socket.onmessage = (event) => {
            // Push incoming message to buffer (not directly to state)
            bufferRef.current.push(event.data);
        };

        socket.onerror = (error) => {
            console.error("❌ WebSocket Error:", error);
        };

        socket.onclose = () => {
            console.log("🔌 WebSocket disconnected");
        };

        // Flush buffer every 100 ms
        const interval = setInterval(() => {
            if (bufferRef.current.length > 0) {
                setMessages((prev) => [...prev, ...bufferRef.current].slice(-100)); // keep last 100
                bufferRef.current = [];
            }
        }, 100);

        return () => {
            clearInterval(interval);
            socket.close();
        };
    }, []);

    return (
        <div style={{ padding: "20px" }}>
            <h2>Live EUR/USD Forex Data (100ms updates)</h2>
            <div
                style={{
                    background: "#f5f5f5",
                    padding: "10px",
                    marginTop: "10px",
                    borderRadius: "5px",
                    height: "300px",
                    overflowY: "auto",
                }}
            >
                {messages.map((msg, index) => (
                    <p key={index}>{msg}</p>
                ))}
            </div>
        </div>
    );
};

export default ForexWebSocket;
